<script>
import moment from "moment";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import store from "../../vuex/store";

export default {
  components: {
    ButtonWithLoadWebsite,
  },
  props: {
    knowledge: {
      type: Object,
      required: true,
    },
    updateKnowledge: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      currentKnowledge: {
        id: null,
        data: "",
        updatedAt: null,
        websiteId: null,
      },
      minLength: 10,
      maxLength: 3500,
      errorMessage: "",
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    timeFromLastTraining() {
      if (this.currentKnowledge.updatedAt) {
        return moment(new Date(this.currentKnowledge.updatedAt)).fromNow();
      }
      return 0;
    },
    isTextLengthError() {
      const text = this.currentKnowledge.data;
      if (text.length < this.minLength) {
        this.errorMessage = `Min length ${this.minLength}`;
        return true;
      }

      if (text.length >= this.maxLength) {
        this.errorMessage = `Max length ${this.maxLength}`;
        return true;
      }

      this.errorMessage = "";
      return false;
    },
  },
  watch: {
    knowledge: {
      handler(newData) {
        this.updateCurrentKnowledge(newData);
      },
      deep: true,
    },
  },
  methods: {
    updateCurrentKnowledge(knowledge) {
      this.currentKnowledge = knowledge;
    },
    deleteKnowledge() {
      this.$emit("deleteKnowledge", this.currentKnowledge.id);
    },
  },
  mounted() {
    this.currentKnowledge = this.$props.knowledge;
  },
};
</script>

<template>
  <form @submit.prevent="() => updateKnowledge(currentKnowledge)">
    <div class="textarea__box">
      <textarea
        class="textarea"
        v-model="currentKnowledge.data"
        v-bind:class="{ error: isTextLengthError }"
      />

      <p v-if="isTextLengthError" class="error-message">
        {{ errorMessage }}
      </p>
    </div>

    <div
      class="knowledge_footer"
      v-bind:class="{ knowledge_footer_align: isTextLengthError }"
    >
      <p v-show="!isTextLengthError" class="last_update">
        Last update: {{ timeFromLastTraining }}
      </p>

      <div class="edit_knowledge_actions">
        <ButtonWithLoadWebsite
          type="submit"
          :title="'Save'"
          :isDisabled="isTextLengthError"
        />

        <ButtonWithLoadWebsite
          type="button"
          :title="'Delete'"
          :isDisabled="isLoading"
          @onClick="deleteKnowledge"
        />
      </div>
    </div>
  </form>
</template>

<style scoped>
.textarea__box {
  position: relative;
}

.textarea {
  width: 100%;
  min-height: 250px;
  max-height: 500px;
  resize: none;
  position: relative;
  padding: 12px 20px;
  border-radius: 6px;
  border: 1px solid #d1d1d6;

  @media screen and (min-width: 1024px) {
    max-height: 500px;
  }
}

.textarea:focus-visible {
  outline-color: #3056d3;
}

.textarea:focus-visible.error {
  outline-color: red;
}

.error-message {
  position: absolute;
  bottom: -32px;
  left: 0;
  color: red;
  margin: 0;
}

.knowledge_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.knowledge_footer_align {
  justify-content: flex-end;
}

.last_update {
  margin: 0;
  padding: 0;
  color: #828282;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.7;
}

.edit_knowledge_actions {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;

  @media screen and (max-width: 420px) {
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
